<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <div class="overline primary--text pr-1 text-left">
          {{ $t("formula.constant.tableHeader") }}
        </div>
        <v-data-table
          :headers="headers"
          :items="constants"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:header.action="{ props }">
            <v-tooltip bottom v-if="permitted('Formula.Create')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  color="accent"
                  @click="editConstant(null)"
                  v-on="on"
                >
                  <v-icon dark> mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("formula.tooltips.newConstant") }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.updatedAt="{ item }">
            {{
              humanDate(item.updatedAt) != "N/A"
                ? humanDate(item.updatedAt)
                : humanDate(item.createdAt)
            }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon
              v-if="permitted('Formula.Update') && owns(item.companyId)"
              @click="editConstant(item.constantId)"
              class="mr-2"
              color="primary"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              v-if="permitted('Formula.Delete') && owns(item.companyId)"
              dark
              color="error"
              @click="openConfirm(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>

      <v-dialog v-model="createDialog" min-width="86vh" max-width="90vh">
        <create-constant-form :constantId="currentId" @update="reload" />
      </v-dialog>

      <delete-constant-dialog
        :show="deleteDialog"
        v-model="currentConstant"
        @update="reload"
        @cancel="hideDelete"
      />
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CreateConstantForm from "./CreateConstantForm.vue";
import DeleteConstantDialog from "./DeleteConstantDialog.vue";

export default {
  name: "ConstantList",

  data() {
    return {
      deleteDialog: false,
      createDialog: false,
      currentId: null,
      currentConstant: null,

      headers: [
        { text: this.$t("formula.fields.name"), value: "name" },
        {
          text: this.$t("formula.fields.isGlobal"),
          value: "isGlobal",
        },
        {
          text: this.$t("formula.fields.value"),
          value: "value",
        },
        { text: this.$t("formula.fields.updatedAt"), value: "updatedAt" },
        { text: "", value: "action", sortable: false },
      ],
    };
  },

  computed: {
    ...mapState("formulas", ["constants"]),
  },
  methods: {
    ...mapActions("formulas", ["getConstants"]),

    editConstant(id) {
      this.currentId = id;
      this.createDialog = true;
    },

    openConfirm(constant) {
      this.currentConstant = constant;
      this.deleteDialog = true;
    },

    async reload() {
      await this.getConstants();
      await this.hideDelete();
    },

    async hideDelete() {
      this.createDialog = false;
      this.deleteDialog = false;
    },
  },

  async created() {
    await this.getConstants();
  },

  components: {
    CreateConstantForm,
    DeleteConstantDialog,
  },
};
</script>
